define([
    // ここに書く
    'app/signage/SignageAdminPage',
    'app/signage/display/SignageDisasterPreventionStatusPage',
    'app/signage/SignageMapSettingPage',
    'app/signage/display/SignageDamageOverviewPage',
    'app/signage/display/SignageDamageListPage',
    'app/signage/display/SignageShelterOverviewPage',
    'app/signage/display/SignageShelterListPage',
    'app/signage/display/SignageEvacOrderOverviewPage',
    'app/signage/display/SignageEvacOrderHistory',
    'app/signage/display/SignageMapPage',
    'app/signage/display/SignageThematicEvacPage',
    'app/signage/display/SignageChronologyOverviewPage',
    'app/signage/display/SignageChronologyListPage',
    'app/signage/display/SignageDisasterPreventionOverviewPage',
    'app/signage/display/SignageLifelineOverviewPage',
    'app/signage/display/SignageObservationOverviewPage',
    'app/signage/display/SignageEarthquakeStatusPage',
    'app/signage/display/SignageWeatherInfoStatusPage'
    // ここまで
], function () { });
